module.exports = "<!-- Increments Voting Software - check vote/vote.component.ts & run: node <proj dir>/index.js -->\n<vote></vote>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main